export default "__VITE_ASSET__Bt$28_Q8__"